import React, { Component } from "react";
import { Grid, Box, Typography } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";

import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  getLastDayofMonthofGivenDate,
  get_FirstDate_of_Given_YMD_Date,
  validatedate_min_max,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchGSTDetails } from "./API";
import ExcelJS from "exceljs";
import CtCmb from "./CustomTool/CtCmb";
import DownloadLink from "./DownloadLink";
import { apiURL } from "./API";

class ExcelGSTR3B extends Component {
  state = {
    fileUrl: "",
    fileName: "GSTR-3B Excel",
    formData: {
      //   dtpFromDate: /*  get_FirstDate_of_Given_YMD_Date(
      //     get_30DaysBack_FromCurrentDate()
      //   )*/ get_FirstDate_of_Given_YMD_Date(get_YMD_from_SYS(new Date())),
      //   dtpToDate:
      //     /* getLastDayofMonthofGivenDate(get_30DaysBack_FromCurrentDate()) */ getLastDayofMonthofGivenDate(
      //       get_YMD_from_SYS(new Date())
      //     ),
      cmbYear: "",
      cmbFormat: "Original",
    },
    isFileGenerated: false,
    dataLoadStatus: true,
    ARD: null,
    FormatList: [{ vac_format: "Original" }, { vac_format: "Format 2" }],

    YearList: [
      { vac_year: "Apr " + localStorage.getItem("ACY") },
      { vac_year: "May " + localStorage.getItem("ACY") },
      { vac_year: "Jun " + localStorage.getItem("ACY") },
      { vac_year: "Jul " + localStorage.getItem("ACY") },
      { vac_year: "Aug " + localStorage.getItem("ACY") },
      { vac_year: "Sep " + localStorage.getItem("ACY") },
      { vac_year: "Oct " + localStorage.getItem("ACY") },
      { vac_year: "Nov " + localStorage.getItem("ACY") },
      { vac_year: "Dec " + localStorage.getItem("ACY") },
      { vac_year: "Jan " + (parseInt(localStorage.getItem("ACY")) + 1) },
      { vac_year: "Feb " + (parseInt(localStorage.getItem("ACY")) + 1) },
      { vac_year: "Mar " + (parseInt(localStorage.getItem("ACY")) + 1) },
      // { vac_year: "Apr " + new Date().getFullYear() },
      // { vac_year: "May " + new Date().getFullYear() },
      // { vac_year: "Jun " + new Date().getFullYear() },
      // { vac_year: "Jul " + new Date().getFullYear() },
      // { vac_year: "Aug " + new Date().getFullYear() },
      // { vac_year: "Sep " + new Date().getFullYear() },
      // { vac_year: "Oct " + new Date().getFullYear() },
      // { vac_year: "Nov " + new Date().getFullYear() },
      // { vac_year: "Dec " + new Date().getFullYear() },
      // { vac_year: "Jan " + (new Date().getFullYear() + 1) },
      // { vac_year: "Feb " + (new Date().getFullYear() + 1) },
      // { vac_year: "Mar " + (new Date().getFullYear() + 1) },
    ],
  };

  //#region Component
  componentDidMount() {
    // document.title = "AccountSoftware : GSTR-3B";
    this.props.setActiveMenu("ExcelGSTR3B");
    this.onFormLoad();
  }
  //#endregion Component

  //#endregion handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  //   handleChangeSalesRowsPerPage = (rowsPerPage) => {
  //     this.setState({ SalesrowsPerPage: rowsPerPage });
  //   };
  //   handleChangePurchaseRowsPerPage = (rowsPerPage) => {
  //     this.setState({ PurchaserowsPerPage: rowsPerPage });
  //   };

  //#region handle

  //#region function

  getMonthName = (month) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return monthNames[month];
  };

  onFormLoad = () => {
    let monthNumber = new Date().getMonth(),
      Year = new Date().getFullYear(),
      monthName = this.getMonthName(monthNumber - 1);

    let cmbYear =
      monthName === "Mar"
        ? ""
        : monthName === "Jan" || monthName === "Feb"
        ? monthName + " " + (Year + 1)
        : monthName + " " + Year;
    this.setState({
      formData: {
        ...this.state.formData,
        cmbYear,
      },
    });
  };

  getSumOfRow = (rows, column) => {
    let Sum = 0;
    rows.map((row) => {
      Sum += Number(row[column]);
    });
    return Sum;
  };

  validateYear = () => {
    let result = false;
    if (this.state.formData.cmbYear.length <= 0) {
      this.props.toastErrorMsg("Select Year", "cmbYear");
    } else {
      result = true;
    }
    return result;
  };

  generateExcel = () => {
    if (this.validateYear()) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "GSTR3B",
        bint_acid: localStorage.getItem("acid"),
        vac_monthyear: this.state.formData.cmbYear,
        vac_format: this.state.formData.cmbFormat,
      };
      fetchGSTDetails(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          // let fileUrl = res.data.DownloadLink;
          // this.setState(
          //   {
          //     fileUrl,
          //     isFileGenerated: true,
          //   },
          //   () => {}
          // );
          // })
          // .catch((error) => {
          //   console.log("Unknown error occurred in getLedgerList.", error);

          if (res.data.msgType === "success" && res.data.DownloadLink) {
            this.setState({
              fileUrl: res.data.DownloadLink,
              isFileGenerated: true, // Show link
            });
          } else {
            this.setState({
              fileUrl: "",
              isFileGenerated: false, // Hide link
            });
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in getLedgerList.", error);
          this.setState({
            fileUrl: "",
            isFileGenerated: false, // Hide link on error
          });
        });
    }
  };

  // //#endregion function

  render() {
    // let SalesrowsCount = this.state.Salesrows.length,
    //   PurchaserowsCount = this.state.Purchaserows.length;
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>GSTR-3B</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbYear"
              label="Year"
              items={this.state.YearList}
              value={this.state.formData.cmbYear}
              handleOnChange={this.handleOnChange}
              width={170}
              maxLength={20}
              colID="vac_year"
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbFormat"
              label="Format"
              items={this.state.FormatList}
              value={this.state.formData.cmbFormat}
              handleOnChange={this.handleOnChange}
              width={170}
              maxLength={20}
              colID="vac_format"
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtBtn
              label="Generate Excel"
              onClick={this.generateExcel}
              iconName={"excel"}
            />
          </Grid>
          {this.state.isFileGenerated && (
            <Grid item>
              <DownloadLink
                fileUrl={apiURL + this.state.fileUrl}
                fileName={this.state.fileName}
              />
            </Grid>
          )}
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HoCtToastContainer(withRouter(ExcelGSTR3B)));
